// Build statique : pré-rendu et pas de SSR runtime
export const prerender = true;
export const ssr = false;
export const trailingSlash = 'never';
